<template>
  <svg class="list-grid-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" viewBox="0 0 24 24">
    <g stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M3 3h7v7H3z" />
      <path d="M14 3h7v7h-7z" />
      <path d="M14 14h7v7h-7z" />
      <path d="M3 14h7v7H3z" />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'IconListGrid',
  }
</script>
<style lang="scss">
  .list-grid-icon{
    width: 16px;
    > g{
      fill: none;
      stroke: var(--projectPrimaryColor);
    }
  }
</style>